export enum InputType {
    TEXT,
    NUMBER
  }
  